import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import {
  ADD_WISHLIST,
  CART_DELETE,
  CART_DETAILS,
  CART_INSERT,
  CART_UPDATE,
  GET_CART_SUMMARY,
  GET_COUPON,
  GET_WISHLIST,
  PAY_NOW,
  PURCHASE,
  USE_COUPON,
} from "../routes";

export const CartApi = createApi({
  reducerPath: "CartApi",
  baseQuery,
  endpoints: (builder) => ({
    addToCart: builder.mutation<
      CartResponse,
      {
        unique_id: string;
        attributes_id: number;
        product_id: number;
        price: string;
        mrpprice: string;
        presc_required: number;
        unit_type: string;
        quantity: number;
        user_id?: number;
      }
    >({
      query: (credentials) => ({
        url: CART_INSERT,
        method: "POST",
        body: credentials,
      }),
    }),
    updateCart: builder.mutation<
      CartResponse,
      {
        unique_id: string;
        quantity: number;
        cart_id: number;
        user_id?: number;
      }
    >({
      query: (credentials) => ({
        url: CART_UPDATE,
        method: "POST",
        body: credentials,
      }),
    }),

    removeCart: builder.mutation<
      CartResponse,
      {
        cart_id: Number;
      }
    >({
      query: (credentials) => ({
        url: CART_DELETE,
        method: "POST",
        body: credentials,
      }),
    }),
    getCart: builder.query<
      CartResponse,
      { unique_id: string; user_id?: number }
    >({
      query: (data) => ({
        url: CART_DETAILS,
        params: { unique_id: data.unique_id, user_id: data.user_id },
      }),
    }),
    addToWishlist: builder.mutation<
      CartResponse,
      {
        attribute_id: number;
        product_id: number;
        product_name: string;
        action_type: number;
        unique_id: string;
        user_id?: number;
      }
    >({
      query: (credentials) => ({
        url: ADD_WISHLIST,
        method: "POST",
        body: credentials,
      }),
    }),
    getWishlist: builder.query<
      CartResponse,
      { unique_id: string; user_id?: number }
    >({
      query: (data) => ({
        url: GET_WISHLIST,
        params: { unique_id: data.unique_id, user_id: data.user_id },
      }),
    }),
    getCartSummary: builder.query<
      CartResponse,
      { coupon_code?: string; user_id?: number; unique_id: string }
    >({
      query: (data) => ({
        url: GET_CART_SUMMARY,
        params: {
          coupon_code: data.coupon_code ? data.coupon_code : undefined,
          user_id: data.user_id,
          unique_id: data.unique_id,
        },
      }),
      keepUnusedDataFor: 0,
    }),
    getCoupon: builder.query({
      query: (user_id) => ({
        url: GET_COUPON,
        params: { user_id },
      }),
      transformResponse: (response: ApiResponse<CouponTypes[]>) => {
        return response?.data;
      },
    }),

    useCoupon: builder.mutation<
      CartResponse,
      {
        coupon_code: string;
        amount: string;
        saleValue: string;
      }
    >({
      query: (credentials) => ({
        url: USE_COUPON,
        method: "POST",
        body: credentials,
      }),
    }),
    payNow: builder.mutation<OrderApiResponse, {}>({
      query: (credentials) => ({
        url: PAY_NOW,
        method: "POST",
        body: credentials,
      }),
    }),
    purchase: builder.mutation<any, {}>({
      query: (credentials) => ({
        url: PURCHASE,
        params: credentials,
      }),
    }),
  }),
});

export const {
  useAddToCartMutation,
  useUpdateCartMutation,
  useRemoveCartMutation,
  useGetCartQuery,
  useAddToWishlistMutation,
  useGetWishlistQuery,
  useGetCouponQuery,
  useUseCouponMutation,
  useGetCartSummaryQuery,
  usePayNowMutation,
  usePurchaseMutation,
} = CartApi;
